import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':toolId'}/update`;

export const ROUTE: RouteDefinition = `${baseRoute}/:toolId/update`;

export const URL = (toolId: number): RouteDefinition => `${baseRoute}/${toolId}/update`;
